module.exports = __webpack_public_path__ + "img/32Ox5O.8c38e45b.svg";